// actions.ts
import { Context, ISaveFinancialReportPayload, IActions } from './actions.types'
import { RootState } from '@/store/types'
import { Notification, INotification } from '@/entities'
import { ActionTree } from 'vuex';
import { AppConstants as _app } from '@/shared/app.constants'

export const actions: IActions = {
   
    /** set the finacial report state on selection */
    getFinancialReport(context: Context, id: number): any {
        if(id) {            
            return this.$services.monitor.getFinancialReport(id)
            .then((data: any) => {
                context.commit('setFinancialReport', { report: data });
                return data;
            });
        }
    },

    getGrantInfo(context: Context, id: number): any {
        if(id) {
            // get currency dropdownlist
            return this.$services.monitor.getCurrency()
            .then((currency: any) => {
                context.commit('setCurrency', currency);
                context.commit('application/updateOverlay', true, { root: true });
                return this.$services.monitor.getGrantInfo(id)
                    .then((result: any) => {        
                        let tmp = result.template.reduce((obj: any, tmpl: any) => {
                            obj[tmpl.Key] = tmpl.Value;
                            return obj;
                        }, {});
                        context.commit('setTemplate', {template : tmp})
                        
                        let data = this.$services.monitor.transformForecastEntity(
                            result.data,
                            context.getters.forecastTemplate,
                            context.getters.isRAG
                        );
                        result.data = data;
                        context.commit('setGrant', result);
                        context.commit('application/updateOverlay', false, { root: true });
                        return result;
                    });
            });
        }
    },

    getAppBudgetForGrant(context: Context, params: any): any {
        if(params.id) {
            context.commit('application/updateOverlay', true, { root: true });
            return this.$services.monitor.getAppBudgetForGrant(params.id, params.financialReportId, params.period)
                .then((result: any) => {
                    if (result.Result === 'ERROR') {
                        context.commit('setAppBudgetForGrant', []);
                        context.commit('application/updateOverlay', false, { root: true });
                    } else {
                        context.commit('setAppBudgetForGrant', result);
                        context.commit('application/updateOverlay', false, { root: true });
                        return result;
                    }
                });
        }
    },

    /** Start the financial Report */
    startFinancialReport(context: Context, id: number): any {
        if(id) {            
            return this.$services.monitor.startFinancialReport(id)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    return data;
                    // context.commit('application/setNotification', new Notification({ snack: true, text: 'Financial Report saved successfully', color: 'success' } as INotification),  { root: true });         
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
                }
            });
        }
    },

    /** update the technical report period */
    updateReportPeriod(context: Context, payload: ISaveFinancialReportPayload): any {
        return this.$services.monitor.updateFinancialReportPeriod(payload.id, payload.data)
            .then((resp: any) => {
                if (resp.Result === 'OK') {
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Financial Report saved successfully', color: 'success' } as INotification),  { root: true });         
                    return resp.Record;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: resp.Message, color: 'error' } as INotification),  { root: true })
                }
                
            });
    },

    /** save the financial report */
    saveFinancialReport(context: Context, payload: ISaveFinancialReportPayload): any {
        return this.$services.monitor.updateFinancialReport(payload.id, payload.data)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    context.commit('setFinancialReport', { report: data.Record });
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Financial Report saved successfully', color: 'success' } as INotification),  { root: true });
                    return data;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
                }
                
            });
    },

    saveFinancialReportData(context: Context, payload: any): any {
        return this.$services.monitor.saveFinancialReport(payload.reportId, payload.data, payload.section)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    // convert back to json form compatible format
                    let datum = this.$services.monitor.transformForecastEntity(
                        data.Record,
                        context.getters.forecastTemplate,
                        context.getters.isRAG
                    );
                    context.commit('refreshModel', { report: datum });
                    if(payload.context !== 'submit') {
                        context.commit('application/setNotification', new Notification({ snack: true, text: 'Financial Report saved successfully', color: 'success' } as INotification),  { root: true });
                    }
                    return data;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
                }
            });
    },

    saveFinancialReportDirty(context: Context, payload: any): any {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.monitor.saveFinancialReport(payload.reportId, payload.data, payload.section)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    // convert back to json form compatible format
                    let datum = this.$services.monitor.transformForecastEntity(
                        data.Record,
                        context.getters.forecastTemplate,
                        context.getters.isRAG
                    );
                    context.commit('refreshModel', { report: datum });
                    if(payload.context !== 'submit') {
                        context.commit('application/updateOverlay', false, { root: true });
                        // context.commit('application/setNotification', new Notification({ snack: true, text: 'Financial Report saved successfully', color: 'success' } as INotification),  { root: true });
                    }
                    return data;
                } else {
                    context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
                }
            });
    },

    updateSelectedKey(context: Context, payload: any) {
        context.commit('updateSelectedKey', payload);
    },

    uploadDocument(context: Context, payload: any) {
        return this.$services.document.uploadDocument(payload.file, payload.schema, payload.transactionId, payload.language)
        .then((resp) => {
            return resp;
        }).catch((e) => {
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification));
        })
    },

    uploadReport(context: Context, payload: any) {
        context.commit('application/updateOverlay', true, { root: true });
        return this.$services.monitor.importFile( payload.file, payload.reportId, payload.appId, payload.type)
        .then((resp) => {
            if(resp.Result === 'OK') {
                context.commit('application/updateOverlay', false, { root: true });
                return resp.Data;
            } else {
                context.commit('application/updateOverlay', false, { root: true });
                context.commit('application/setNotification', new Notification({ snack: true, text: resp.Message, color: 'error' } as INotification), { root: true });
            }
        }).catch((e) => {
            context.commit('application/updateOverlay', false, { root: true });
            context.commit('application/setNotification', new Notification({ snack: true, text: e, color: 'error' } as INotification), { root: true });
        });
    },

    updateAuditDocs(context: Context, payload: any) {
        return this.$services.monitor
        .requestSamples(payload.auditRequest, payload.transactionId, payload.section)
        .then((data: any) => {
            if (data) {
                context.commit('updateAuditDocs', data);

                return true;
            } else {
                return false;
            }
        });
    }
}